/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoicingModeType = {
    Direct: 'DIRECT',
    Intermediation: 'INTERMEDIATION'
} as const;
export type InvoicingModeType = typeof InvoicingModeType[keyof typeof InvoicingModeType];


export function instanceOfInvoicingModeType(value: any): boolean {
    for (const key in InvoicingModeType) {
        if (Object.prototype.hasOwnProperty.call(InvoicingModeType, key)) {
            // @ts-ignore
            if (InvoicingModeType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoicingModeTypeFromJSON(json: any): InvoicingModeType {
    return InvoicingModeTypeFromJSONTyped(json, false);
}

export function InvoicingModeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicingModeType {
    return json as InvoicingModeType;
}

export function InvoicingModeTypeToJSON(value?: InvoicingModeType | null): any {
    return value as any;
}

